module.exports = __webpack_public_path__ + "static/media/ligth.3e7224e8.svg";